import { useState } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import AdvancedPostcodesFilters from "./AdvancedPostcodesFilters";
import PostcodeInput from "../Common/PostcodeInput";

const PostcodesFilters = ({ onFilterChange }) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // State to toggle advanced filters

  return (
    <Container className="mt-4">
      <Form>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                placeholder="__-____"
                inputMode="numeric"
                onChange={(val) => onFilterChange("postcode", val)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="streetName">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("Street", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalDR">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("terminalDR", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalEX">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("terminalEX", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              {showAdvancedFilters ? "Podstawowy" : "Zaawansowany"}
            </Button>
          </Col>
        </Row>
        {showAdvancedFilters && (
          <AdvancedPostcodesFilters onFilterChange={onFilterChange} />
        )}
      </Form>
    </Container>
  );
};

export default PostcodesFilters;
